var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/interface/aside.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/interface/aside.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "comboboxes")),"Combobox");
if(t_6) {var t_4;
if(runtime.isArray(t_6)) {
var t_5 = t_6.length;
for(t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4][0]
frame.set("name", t_6[t_4][0]);
var t_8 = t_6[t_4][1]
frame.set("combobox", t_6[t_4][1]);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n<div class=\"session combobox\" data-session=\"";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += "\">\r\n\t";
output += runtime.suppressValue((lineno = 3, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.contextOrFrameLookup(context, frame, "this"),t_8])), env.opts.autoescape);
output += "\r\n</div>\r\n";
;
}
} else {
t_4 = -1;
var t_5 = runtime.keys(t_6).length;
for(var t_9 in t_6) {
t_4++;
var t_10 = t_6[t_9];
frame.set("name", t_9);
frame.set("combobox", t_10);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\r\n<div class=\"session combobox\" data-session=\"";
output += runtime.suppressValue(t_9, env.opts.autoescape);
output += "\">\r\n\t";
output += runtime.suppressValue((lineno = 3, colno = 25, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.contextOrFrameLookup(context, frame, "this"),t_10])), env.opts.autoescape);
output += "\r\n</div>\r\n";
;
}
}
}
frame = frame.pop();
output += "\r\n\r\n";
if(runtime.contextOrFrameLookup(context, frame, "moduleMenu") != runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n<div class=\"tree-view\">\r\n\t";
frame = frame.push();
var t_13 = runtime.contextOrFrameLookup(context, frame, "moduleMenu");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("branch", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\r\n\t<div class=\"branch\">\r\n\t\t<div class=\"branch-name\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_14),"Text")), env.opts.autoescape);
output += "</div>\r\n\t\t<div class=\"branches\">\r\n\t\t\t";
frame = frame.push();
var t_17 = runtime.memberLookup((t_14),"children");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("branch2", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\r\n\t\t\t<div class=\"branch collapsed\">\r\n\t\t\t\t<div class=\"branch-name\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"Text"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t<div class=\"branches\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_21 = runtime.memberLookup((t_18),"children");
if(t_21) {var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("branch3", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += "\r\n\t\t\t\t\t<div class=\"stick\" data-menu-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_22),"ID"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_22),"Text"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
}
frame = frame.pop();
output += "\r\n</div>\r\n";
;
}
output += "\r\n\r\n";
if(runtime.contextOrFrameLookup(context, frame, "licenseExpirationMessage") != runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n<div class=\"text-warning-aside\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "licenseExpirationMessage"), env.opts.autoescape);
output += "</div>\r\n";
;
}
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/interface/aside.html"] , dependencies)